import { Fragment, useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../components/Sidebar";
import Header from "../components/Header";
import { Scrollbars } from "rc-scrollbars";

const MainLayout = () => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <Fragment>
      <div className="bg-white d-flex position-relative">
        <SideBar
          mobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
        />
        <div className="p-0 w-100 vh-100" style={{ minWidth: 0 }}>
          <Header onMenuClick={() => setMobileSidebarOpen(true)} />
          <Scrollbars
            autoHide={false}
            autoHeight
            autoHeightMax="calc(100vh - 95px)"
            style={{
              width: "100%",
              overflow: "hidden",
            }}
            renderThumbVertical={({ style, ...props }) => (
              <div
                {...props}
                style={{
                  ...style,
                  backgroundColor: "#AAA", // Change color
                  borderRadius: "4px",
                }}
              />
            )}
          >
            <div
              className="main-container h-100 px-xl-5 px-3 py-3 mb-3"
              style={{ width: "100%", minWidth: 0 }}
            >
              <Outlet />
            </div>
          </Scrollbars>
        </div>
      </div>
    </Fragment>
  );
};

export default MainLayout;
